
export const appInfo = {
  title: 'Indigovieweb'
};

export default appInfo;
